// Created by hejikun on 2017/11/2 0002.
let aged = [
  {
    path: '/aged_index',
    name: '敬老版',
    component: () => import('@/pages/agedUse/aged_index')
  },
  {
    path: '/aged_hoslist',
    name: '医院列表',
    component: () => import('@/pages/agedUse/aged_hoslist')
  },
  {
    path: '/aged_branch_hospital',
    name: '医院列表',
    component: () => import('@/pages/agedUse/aged_branch_hospital')
  },
  {
    path: '/aged_depart_list',
    name: '科室列表',
    component: () => import('@/pages/agedUse/aged_depart_list')
  },
  {
    path: '/aged_secondary_depart',
    name: '科室列表',
    component: () => import('@/pages/agedUse/aged_secondary_depart')
  },
  {
    path: '/aged_yunda_depart',
    name: '科室列表',
    component: () => import('@/pages/agedUse/aged_yunda_depart')
  },
  {
    path: '/aged_third_depart',
    name: '科室列表',
    component: () => import('@/pages/agedUse/aged_third_depart')
  },
  {
    path: '/aged_doctor_list',
    name: '医生列表',
    component: () => import('@/pages/agedUse/aged_doctor_list')
  },
  {
    path: '/aged_doctor_detail',
    name: '医生详情',
    component: () => import('@/pages/agedUse/aged_doctor_detail')
  },
  {
    path: '/aged_fuwai_depart',
    name: '科室列表',
    component: () => import('@/pages/agedUse/aged_fuwai_depart')
  },
  {
    path: '/aged_order_confirm',
    name: '预约信息确认',
    component: () => import('@/pages/agedUse/aged_order_confirm')
  },
  {
    path: '/aged_collect_doctors',
    name: '收藏医生',
    component: () => import('@/pages/agedUse/aged_collect_doctors')
  }
]

export default aged
